// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkMetadata
export const SDK_NAME = 'sentry.javascript.node';
